<p-toast [baseZIndex]="10000"></p-toast>

<p-contextMenu [baseZIndex]="10000" rejectButtonStyleClass="p-button-text"></p-contextMenu>
@if(isLoadingCustomer){
  <p-progressSpinner class="mt-5 flex justify-content-center"></p-progressSpinner>
} @else {
<div class="row d-flex justify-content-center macro-groups" [@fadeIn]="true">
  <div class="col-7">
    <p-panel header="{{ 'MacroGroups Load' | translate }}">
      @if(isLoading){
        <p-progressSpinner class="mt-3 flex justify-content-center"></p-progressSpinner>
      }
      <form #loadMacroGroups="ngForm" id="loadMacroGroups" class="mt-4" validate *ngIf="!isLoading">
        <div class="p-fluid grid">
          <div class="offset-1 p-field col-3">
            <p-floatlabel>
              <p-select
                name="customer"
                #customer="ngModel"
                appendTo="body"
                optionLabel="name"
                class="w-100"
                [options]="customerList"
                [(ngModel)]="customerSelected"
                [filter]="true"
                [emptyMessage]="(isLoadingCustomer ? 'Loading' : 'Common.No Results Found') | translate"
                required
              />
              <label class="required" for="customer" translate> Common.Customer </label>
              <small *ngIf="loadMacroGroups.controls.customer?.dirty && loadMacroGroups.controls.customer?.errors?.required" class="text-danger" translate> Generic Errors.Required Customer </small>
            </p-floatlabel>
          </div>
          <div class="col-4 d-flex justify-content-start">
            <p-fileupload #file name="selectedFile" [auto]="true" mode="basic" accept=".csv,.txt,.unl" [disabled]="selectedFile?.size" (onSelect)="selectFile($event)"
              chooseLabel="{{ 'Select File' | translate }}"
              invalidFileTypeMessageSummary="{{ 'Invalid File Type'| translate }}"
              invalidFileTypeMessageDetail="{{ 'Allowed Types Files'| translate: { allowedTypesFiles: '.csv,.txt,.unl' } }}"
            >
            </p-fileupload>
          </div>
          @if(selectedFile?.size > 0){
            <div class="p-field col d-flex justify-content-end">
              <div class="file-label">
                <span>{{ selectedFile.filename }}</span>
              </div>
              <p-button link="true" severity="danger" type="button" class="ml-2 mt-1" icon="pi pi-trash" (click)="deleteFile()"></p-button>
            </div>
          }
        </div>
        <div class="flex justify-content-end mt-3">
          <p-button severity="primary" icon="pi pi-save" label="{{ 'Common.Save' | translate }}" (click)="saveMacroGroupFile()" [disabled]="loadMacroGroups.invalid || selectedFile == undefined || selectedFile?.size == 0"> </p-button>
        </div>
      </form>
    </p-panel>
  </div>
</div>
}
